import React, { useRef } from "react";

import { Input } from "../Input/Input";
import { IconType } from "../Icon/Icon";

interface Props {
  search: string;
  setSearch: (search: string) => void;
  placeholder?: string;
  width?: string;
  isBorderless?: boolean;
  isFocusedAutomatically?: boolean;
  isDisabled?: boolean;
  rightIcon?: { name: IconType; onClick?: () => void } | false;
  refSearch?: React.RefObject<HTMLInputElement>;
  /**
   * Optional side-effect for the built-in clear icon. The field is always reset
   * via `setSearch("")` first; `onClear` then runs in addition, letting callers
   * react to an explicit clear (e.g. also reset an applied/committed search in
   * the parent) without owning the input-reset responsibility.
   */
  onClear?: () => void;
}

export const Search = ({
  search,
  setSearch,
  placeholder = "Search",
  width,
  isBorderless,
  isFocusedAutomatically,
  isDisabled,
  rightIcon,
  refSearch: refSearchForwarded,
  onClear,
}: Props) => {
  const refSearch = useRef<HTMLInputElement>(null);

  const getRef = () => {
    return refSearchForwarded || refSearch;
  };

  const clearSearch = () => {
    setSearch("");
    onClear?.();
    getRef().current?.focus();
  };

  return (
    <Input
      value={search}
      setValue={setSearch}
      placeholder={`${placeholder}`.replaceAll(".", "") + "..."}
      width={width}
      isBorderless={isBorderless}
      isFocusedAutomatically={isFocusedAutomatically}
      isDisabled={isDisabled}
      leftIcon={{ name: "search" }}
      rightIcon={(search && { name: "clear", onClick: clearSearch }) || rightIcon}
      refInput={refSearchForwarded || refSearch}
    />
  );
};
